import React from 'react';
import { Container, Row } from 'react-bootstrap';
import ReactMarkdown from 'react-markdown';

function CandidateExecutiveSummary({ comments }) {
  console.log(JSON.stringify(comments));
  return (
    <>
      <Container className="bg-white mt-2 mb-3 candidate-profile-assessments">
        <Row className="justify-content-center pt-4">Feedback Summary</Row>
        <Row className="justify-content-center w-25 mx-auto pt-3">
          <hr style={{ borderTop: '2px solid' }} />
        </Row>
        <Row className="w-75 mx-auto pt-5">
          <ReactMarkdown className="feedback-md">{comments}</ReactMarkdown>
        </Row>
      </Container>
    </>
  );
}

export default CandidateExecutiveSummary;
